<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="form-contain">
    <a-spin :spinning="confirmLoading">
      <detail-list :col="3" size="small">
          <detail-list-item :term="$t('命令标识')">{{model.commandId}}</detail-list-item>
          <detail-list-item :term="$t('创建人')">{{model.createBy}}</detail-list-item>
          <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
        </detail-list>
        <detail-list size="small">
          <detail-list-item :term="$t('命令类型')">{{$t(commandNameList[model.cmd])}}</detail-list-item>
          <detail-list-item :term="$t('表类型')">{{$t(meterTypeObj[model.meterType])}}</detail-list-item>
          <!--<detail-list-item term="指令标记帧">{{model.mid}}</detail-list-item>-->
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('状态')">{{$t(reportStatusObj[model.status])}}</detail-list-item>
          <detail-list-item :term="$t('发送时间')">{{model.sendTime}}</detail-list-item>
          <detail-list-item :term="$t('回应时间')">{{model.receiveTime}}</detail-list-item>
        </detail-list>
      <a-form :colon="colon" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item  :label="$t('命令参数')">
              <a-textarea :readOnly="disableSubmit" :placeholder="$t('请输入命令参数')" v-model="model.cmdParam" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model.receiveContent!=''&&model.receiveContent!=null">
            <a-form-item  :label="$t('命令回应内容')">
              <a-textarea :readOnly="disableSubmit" placeholder="" v-model="model.receiveContent" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item  label="备注">
              <a-textarea :readOnly="disableSubmit" placeholder="请输入备注" v-decorator="['remark', {}]" />
            </a-form-item>
          </a-col> -->
        </a-row>
      </a-form>
    </a-spin>
    </div>
  </j-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'

  export default {
    name: "PartCommandDykjModal",
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("操作"),
        meterTypeObj,
        disableSubmit: false,
        visible: false,
        colon: false,
        model: {},
        reportStatusObj: reportStatusObj,
        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/model/partCommand/add",
          edit: "/model/partCommand/edit",
        },
        commandNameList: dataFlagObj,
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({},record)
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            formData.sendTime = formData.sendTime?formData.sendTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.receiveTime = formData.receiveTime?formData.receiveTime.format('YYYY-MM-DD HH:mm:ss'):null;
            console.log(formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>
.form-contain{
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>